import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import user from "./modules/user";
import create from "./modules/create";
import modelDesign from "./modules/modelDesign";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    create,
    modelDesign,
  },
  getters,
});
export default store;
